export default "__VITE_ASSET__Bopc8ZXS__"